import type EditorViewState from 'owa-editor/lib/store/schema/EditorViewState';

/**
 * Because there can be multiple simultaneous compose sessions, we need to
 * differentiate between button actions.  We do this by tacking on the current
 * (and unique) editorId
 * @param baseId is the button designation, often a RibbonId (number) but sometimes a string
 * @param viewStateOrEditorId is the current EditorViewState or editorId
 * @returns a unique id for the button, as described above.
 */
export const getComposeRibbonId = (
    baseId: number | string,
    viewStateOrEditorId: EditorViewState | string | undefined
): number | string => {
    let editorId: string = '';
    if (typeof viewStateOrEditorId === 'string') {
        editorId = viewStateOrEditorId;
    } else if (viewStateOrEditorId !== undefined) {
        editorId = viewStateOrEditorId.editorId;
    }
    return editorId ? `${baseId}_${editorId}` : baseId;
};
